const MINUTE = 60 * 1000;

/** React Query stale time: treat cached data as fresh for 5 minutes. */
export const FIVE_MINUTES = 5 * MINUTE;

/** React Query garbage-collection (cache) time: keep data cached for 10 minutes. */
export const TEN_MINUTES = 10 * MINUTE;

/** React Query key prefix for the Resource Totals per-cell proof. */
export const RESOURCE_TOTALS_PROOF_QUERY_KEY = ["resource-totals-proof"] as const;
